// services/StatisticsService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getOverviewStatistics() {
    return api.get(ENDPOINTS.STATISTICS.OVERVIEW);
}
export function getAttemptsTimeline(days = 14) {
    return api.get(ENDPOINTS.STATISTICS.TIMELINE, { params: { days } });
}
export function getScoreDistribution() {
    return api.get(ENDPOINTS.STATISTICS.SCORE_DISTRIBUTION);
}
export function getStatisticsBySubject() {
    return api.get(ENDPOINTS.STATISTICS.BY_SUBJECT);
}
export function getExamStatistics(examId) {
    return api.get(ENDPOINTS.STATISTICS.EXAM(examId));
}
